import { Plus, ListChecks, BookOpen, Building2 } from "lucide-react";
import { cap } from "./persona";

export const PortalHero = ({ contact, company, persona, onRefer }) => (
  <header className="bg-[#0A2342] text-white" data-testid="portal-hero">
    <div className="max-w-5xl mx-auto px-5 pt-8 pb-10 md:pt-12 md:pb-14">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#C8A96B] font-semibold mb-4">
        <Building2 className="w-4 h-4" /> {company.company_name} · Powered by Urban Nest Quest
      </div>
      <p className="text-white/70 text-sm mb-2" data-testid="portal-greeting">
        Welcome back, {contact.first_name || "there"} 👋
      </p>
      <h1 className="text-3xl md:text-4xl font-bold font-['Playfair_Display'] leading-tight">
        Welcome to your Urban Nest Quest Partner Hub
      </h1>
      <p className="mt-3 text-base md:text-lg text-white/85 max-w-2xl">
        Helping the people you refer make their move to Houston easier.
      </p>
      <p className="mt-1.5 text-sm text-white/65 max-w-2xl">
        {cap(persona.cta)}, access relocation resources, and track their progress — all in one place.
      </p>
      <div className="mt-7 flex flex-col sm:flex-row sm:items-center gap-3">
        <button onClick={onRefer} data-testid="portal-hero-refer-btn"
          className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-[#C8A96B] hover:bg-[#B5915A] text-[#0A2342] font-bold text-base transition-colors">
          <Plus className="w-5 h-5" /> {persona.cta}
        </button>
        <div className="flex gap-4 sm:ml-2 text-sm">
          <a href="#referrals" className="inline-flex items-center gap-1.5 text-white/85 hover:text-[#C8A96B] transition-colors py-2" data-testid="portal-hero-view-referrals">
            <ListChecks className="w-4 h-4" /> View Referrals
          </a>
          <a href="#toolkit" className="inline-flex items-center gap-1.5 text-white/85 hover:text-[#C8A96B] transition-colors py-2" data-testid="portal-hero-resources">
            <BookOpen className="w-4 h-4" /> Resources
          </a>
        </div>
      </div>
    </div>
  </header>
);
